import { formataDataBr } from '@/common/boot/Utils'

export const AbasDataType = [
  {
    label: 'Resumo',
    aba: 'resumo',
    items: [
      {
        label: "Informações Gerais",
        cols: '3',
        keys: [
          { type: 'string', label: 'OS', key: 'os' },
          { type: 'string', label: 'Número REC', key: 'numero_rec' },
          { type: 'string', label: 'Status REC', key: 'status_rec' },
          { type: 'string', label: 'Situação', key: 'situacao' },
          { type: 'string', label: 'Cliente Final', key: 'cliente_final' },
          { type: 'string', label: 'Designação Claro', key: 'designacao.designacao' },
          { type: 'string', label: 'Provedor', key: 'provedor.nome' },
          { type: 'string', label: 'Área Técnica', key: 'area_tecnica' },
          { type: 'centro_funcional', label: 'Centro Funcional', key: 'centro_funcional' },
          { type: 'string', label: 'Identificação Acesso Provedor', key: 'identificacao_acesso_provedor'},
          { type: 'string', label: 'Protocolo Provedor', key: 'numero_protocolo'},
          { type: 'string', label: 'SLA (minutos)', key: 'sla_minutos'},
        ]
      }
    ]
  },
  {
    label: 'Circuito',
    aba: 'circuito',
    items: [
      {
        label: "Informações do Circuito",
        cols: '3',
        keys: [
          { type: 'string', label: 'Número REC', key: 'numero_rec'},
          { type: 'string', label: 'Status REC', key: 'status_rec'},
          { type: 'string', label: 'Identificação Acesso Provedor', key: 'identificacao_acesso_provedor'},
          { type: 'string', label: 'Descrição do Problema', key: 'descricao_problema'},
          { type: 'formatDateTime', label: 'Data Abertura Ticket', key: 'data_abertura_ticket'},
          { type: 'formatDateTime', label: 'Data Atendimento Cliente', key: 'data_atendimento_cliente'},
          { type: 'formatDateTime', label: 'Data Agendamento', key: 'data_agendamento'},
          { type: 'string', label: 'SLA (minutos)', key: 'sla_minutos'},
          { type: 'string', label: 'Situação', key: 'situacao'},
        ]
      },
      {
        label: "Controles",
        cols: '3',
        keys: [
          { type: 'string', label: 'CF Emissor', key: 'cf_emissor'},
          { type: 'string', label: 'COMR', key: 'comr'},
          { type: 'string', label: 'Bilhete CR3', key: 'bilhete_cr3'},
          { type: 'string', label: 'Empresa Gerencia', key: 'empresa_gerencia'},
        ]
      }
    ]
  },
  {
    label: 'Dados Cadastrais',
    aba: 'dados_cadastrais',
    items: [
      {
        label: "Informações do Cliente",
        cols: '3',
        keys: [
          { type: 'string', label: 'Razão Social', key: 'dados_cadastrais.razao_social'},
          { type: 'string', label: 'Nome Fantasia', key: 'dados_cadastrais.nome_fantasia'},
          { type: 'string', label: 'CNPJ', key: 'dados_cadastrais.cnpj'},
          { type: 'string', label: 'Conta/Subconta', key: 'dados_cadastrais.conta_subconta'},
          { type: 'string', label: 'Segmento Cliente', key: 'segmento_cliente'},
          { type: 'string', label: 'Tipo Porte', key: 'tipo_porte'},
          { type: 'string', label: 'Classe', key: 'classe'},
        ]
      },
      {
        label: "Responsável Técnico",
        cols: '3',
        keys: [
          { type: 'string', label: 'Nome', key: 'dados_cadastrais.nome_responsavel_tecnico'},
          { type: 'string', label: 'Telefone', key: 'dados_cadastrais.tel_responsavel_tecnico'},
          { type: 'string', label: 'E-mail', key: 'dados_cadastrais.email_responsavel_tecnico'},
          { type: 'string', label: 'Contatos Técnicos', key: 'contatos_tecnicos'},
        ]
      }
    ]
  },
  {
    label: 'Local de Instalação',
    aba: 'local_instalacao',
    items: [
      {
        label: "Endereço",
        cols: '3',
        keys: [
          { type: 'string', label: 'Logradouro', key: 'local_instalacao.endereco_extenso'},
          { type: 'string', label: 'Número', key: 'local_instalacao.numero'},
          { type: 'string', label: 'Complemento', key: 'local_instalacao.complemento'},
          { type: 'string', label: 'Bairro', key: 'local_instalacao.bairro'},
          { type: 'string', label: 'Cidade', key: 'local_instalacao.cidade'},
          { type: 'string', label: 'UF', key: 'local_instalacao.uf'},
          { type: 'string', label: 'CEP', key: 'local_instalacao.cep'},
          { type: 'string', label: 'Sigla Localidade', key: 'local_instalacao.sigla_localidade'},
        ]
      }
    ]
  },
  {
    label: 'Dados do Serviço',
    aba: 'dados_servico',
    items: [
      {
        label: "Serviço Contratado",
        cols: '3',
        keys: [
          { type: 'string', label: 'Serviço Contratado', key: 'servico_contratado'},
          { type: 'string', label: 'Tratamento', key: 'tratamento'},
          { type: 'string', label: 'Designação Serviço', key: 'dados_servico.designacao_servico'},
          { type: 'string', label: 'CNOC', key: 'dados_servico.cnoc'},
          { type: 'string', label: 'Prioridade', key: 'dados_servico.prioridade'},
          { type: 'string', label: 'Porta', key: 'dados_servico.porta'},
          { type: 'string', label: 'Acesso', key: 'acesso'},
          { type: 'string', label: 'Modalidade', key: 'modalidade'},
          { type: 'string', label: 'Velocidade', key: 'velocidade'},
        ]
      }
    ]
  },
  {
    label: 'Acesso de Terceiros',
    aba: 'acesso_terceiro',
    items: [
      {
        label: "Informações de Acesso",
        cols: '3',
        keys: [
          { type: 'string', label: 'Provedor Acesso', key: 'acesso_terceiro.provedor_acesso'},
          { type: 'string', label: 'Designação Acesso', key: 'acesso_terceiro.designacao_acesso'},
          { type: 'string', label: 'Número SEV', key: 'acesso_terceiro.numero_sev'},
          { type: 'string', label: 'Estação Entrega Acesso', key: 'acesso_terceiro.estacao_entrega_acesso'},
          { type: 'string', label: 'Velocidade Acesso', key: 'acesso_terceiro.velocidade_acesso'},
          { type: 'string', label: 'Interface Embratel', key: 'acesso_terceiro.interface_embratel'},
          { type: 'string', label: 'Interface Cliente', key: 'acesso_terceiro.interface_cliente'},
          { type: 'string', label: 'ID Acesso Físico', key: 'acesso_terceiro.id_acesso_fisico'},
          { type: 'string', label: 'Frequência RX', key: 'acesso_terceiro.frequencia_rx'},
          { type: 'string', label: 'Frequência TX', key: 'acesso_terceiro.frequencia_tx'},
          { type: 'string', label: 'Tipo Rede', key: 'acesso_terceiro.tipo_rede'},
        ]
      },
      {
        label: "Detalhes Técnicos",
        cols: '3',
        keys: [
          { type: 'string', label: 'Número Acesso Cliente', key: 'acesso_terceiro.numero_acesso_pra_cliente'},
          { type: 'string', label: 'N° Acesso Provedor', key: 'acesso_terceiro.n_acco_ccto_prov'},
          { type: 'string', label: 'Fila', key: 'acesso_terceiro.fila'},
          { type: 'string', label: 'Bastidor', key: 'acesso_terceiro.bastidor'},
          { type: 'string', label: 'Bloco', key: 'acesso_terceiro.bloco'},
          { type: 'string', label: 'Domínio', key: 'acesso_terceiro.dominio'},
          { type: 'string', label: 'NC', key: 'acesso_terceiro.nc'},
          { type: 'string', label: 'Slot', key: 'acesso_terceiro.slot'},
          { type: 'string', label: 'Porta', key: 'acesso_terceiro.porta'},
          { type: 'string', label: 'Régua', key: 'acesso_terceiro.regua'},
          { type: 'string', label: 'Timeslot', key: 'acesso_terceiro.timeslot'},
          { type: 'string', label: 'Tronco', key: 'acesso_terceiro.tronco'},
          { type: 'string', label: 'Par', key: 'acesso_terceiro.par'},
          { type: 'string', label: 'Observações', key: 'acesso_terceiro.campo_obs'},
        ]
      }
    ]
  },
  {
    label: 'Transmissão',
    aba: 'transmissao',
    items: [
      {
        label: "Dados de Transmissão",
        cols: '3',
        keys: [
          { type: 'string', label: 'Designação Transmissão', key: 'transmissao.designacao_transmissao'},
          { type: 'string', label: 'Status Designação', key: 'transmissao.status_designacao'},
        ]
      }
    ]
  },
  {
    label: 'Informações do Provedor',
    aba: 'provedor',
    items: [
      {
        label: "Dados do Provedor",
        cols: '3',
        keys: [
          { type: 'string', label: 'Nome Provedor', key: 'provedor.nome'},
          { type: 'string', label: 'Responsável', key: 'provedor.responsavel'},
          { type: 'string', label: 'E-mail Responsável', key: 'provedor.email_responsavel'},
          { type: 'string', label: 'Telefone Responsável', key: 'provedor.telefone_responsavel'},
          { type: 'string', label: 'Regional', key: 'provedor.regional'},
          { type: 'string', label: 'UF', key: 'provedor.uf'},
          { type: 'string', label: 'CM', key: 'provedor.cm'},
          { type: 'string', label: 'Cluster', key: 'provedor.cluster'},
        ]
      }
    ]
  },
  {
    label: 'Fechamento',
    aba: 'fechamento',
    items: [
      {
        label: "Dados de Fechamento",
        cols: '3',
        keys: [
          { type: 'string', label: 'Código Anormalidade', key: 'fechamento.cod_anormalidade'},
          { type: 'string', label: 'CF Local Anomalia', key: 'fechamento.cf_local_anomalia'},
          { type: 'formatDateTime', label: 'Data Fechamento', key: 'fechamento.data_fechamento'},
          { type: 'formatDateTime', label: 'Data Restabelecimento', key: 'fechamento.data_restabelecimento'},
          { type: 'string', label: 'Tempo Empresa (min)', key: 'fechamento.tempo_empresa_min'},
          { type: 'string', label: 'Tempo Cliente (min)', key: 'fechamento.tempo_cliente_min'},
          { type: 'string', label: 'CF Responsável', key: 'fechamento.cf_responsavel'},
          { type: 'string', label: 'UD Orçamento', key: 'fechamento.ud_orcamento'},
          { type: 'string', label: 'UD Subordinada', key: 'fechamento.ud_subordinada'},
          { type: 'string', label: 'Parecer Atendimento', key: 'fechamento.parecer_atendimento'},
        ]
      }
    ]
  }
];


const getKeyValue =  (arr, data) => {
  let baseObj = null;
  for(let i = 0; i < arr.length; i++) {
    try {
      const element = arr[i];      
      baseObj = baseObj ? baseObj[element] : data[element];
      
      if( i == arr.length - 1 ) {
        if (baseObj === 0) {
          return '0'
        }
        return (baseObj ? baseObj : '').toString().toUpperCase()
      }
    } catch(e) {
      return '-'
    }
  }
  return '-'
}


export const objectKeyFinder  = (aba, data) => {

  const enumBoolean = {
    0: 'Não',
    1: 'Sim',
    2: 'Não'
  }

  return aba.map(o => {
    const items = o.items.map(l => {
      const keys = l.keys.map(k => {

        if (k.key.includes('.')) {
          const arr = k.key.split('.')
          const orArr = k.orKey ? k.orKey.split('.') : '';

          let valInitial = getKeyValue(arr, data);

          if(!valInitial || valInitial === '-') {
            valInitial = getKeyValue(orArr, data);
          }

          if(!valInitial) {
            valInitial = '-';
          }

          if (k.type == 'formatDateTime') {            
            valInitial = formataDataBr(valInitial)
          }

          if (k.type == 'formatDate') {            
            valInitial = formataDataBr(valInitial, true)
          }

          if (k.type == 'boolean') {       
            valInitial = enumBoolean[valInitial]
          }

          if(k.type == 'money') {
            valInitial = valInitial != '-' ? `${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valInitial)}` : '-';
          }

          k.value = valInitial          
          
        } else {
          
          let valInitial =  (data[k.key] ? data[k.key] : '-')

          if (k.key == '*') {
            valInitial = k.value ? k.value.toString().toUpperCase() : k.value
          }          

          if (k.type == 'formatDateTime') {            
            valInitial = formataDataBr(valInitial)
          }

          if (k.type == 'formatDate') {            
            valInitial = formataDataBr(valInitial, true)
          }

          if (k.type == 'boolean') {
            valInitial = enumBoolean[valInitial]
          }

          if(k.type == 'money') {
            valInitial = `R$ ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valInitial)}`;
          }

          if (k.type == 'centro_funcional') {
            valInitial = data[k.key] || null
            k.areaTecnica = data.area_tecnica || null
          }

          k.value = valInitial
        }

        k.value = k.value && k.value.toString().toUpperCase() == 'SELECIONE' ? '-' : k.value
        k.value = (k.label == 'Terminal' && k.value == 0) ? '-' : k.value

        return k
      });

      return {
        ...l,
        keys: keys
      }
      
    });

    return  {
      ...o,
      items: items,
    }
  });
}
